import React from 'react';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';

import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { constructPhoneRolesString, showAlert } from '../utils/utils';

import DA from '../store/ReduxAccess';
import FormProcessor from '../common/FormProcessor';

import Modal from './Modal';
import NewConsultancyContactPanel from './NewConsultancyContactPanel';
import AlertModal from './AlertModal';

const localStyles = (theme) => ({
  newReferrerOrgModal: {
    maxWidth: '600px',
    minWidth: '600px',
    [theme.breakpoints.down('md')]: {
      top: 260,
    },
  },
});

/*
 * Call with something like:
  <IcfPractitionerModal
    firmType={'Private Practitioner'}
    onSuccess={(visibleFirmType, visibleFirmId, contactId) => this.handleNewFirmSuccess(visibleFirmType, visibleFirmId, contactId)}
    onCancel={() => this.whatever()}
  />
 */

class IcfPractitionerModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
      firmType: this.props.firmType,
      companyName: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zip: '',
      companyDescription: '',
      contactName: '',
      contactJobTitle: '',
      contactDescription: '',
      contactPhone1Roles: '',
      contactPhone1Number: '',
      contactPhone2Roles: '',
      contactPhone2Number: '',
      contactEmail: '',
      contactOwnerId: DA.getLoggedInUserPersonId(),
      webUrl: '',
      shouldShowAlertModal: false,
      alertModalText: '',
    };
  }

  validationPolicy = {
    requireFirmName: true,
    requireFirmType: true,
    requireAddress: false,
    forbidPartialAddress: true,
    allowZipFreeAddress: true,
    requireContact: true,
    requireJobTitle: false,
    requireContactDescription: false,
    requireContactPhone: false,
    requireContactEmail: false,
    requireAtLeaseOneOfContactPhoneOrEmail: true,
  };

  cleanState = {
    errorMessage: undefined,
    firmType: this.props.firmType,
    companyName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: '',
    companyDescription: '',
    contactName: '',
    contactJobTitle: '',
    contactDescription: '',
    contactPhone1Roles: '',
    contactPhone1Number: '',
    contactPhone2Roles: '',
    contactPhone2Number: '',
    contactEmail: '',
    contactOwnerId: DA.getLoggedInUserPersonId(),
  };

  componentDidMount() {
    this.setState({ contactOwnerId: DA.getLoggedInUserPersonId() });
  }

  componentDidUpdate(prevProps) {
    if (this.props.firmType !== prevProps.firmType) {
      this.setState({ firmType: this.props.firmType });
    }
  }

  allPossiblePhoneRoles = ['Mobile', 'Business', 'Home', 'Work', 'Fax'];
  possibleContactPhoneRoles = ['Business', 'Mobile', 'Fax'];

  erase() {
    this.setState({ ...this.cleanState });
  }

  onSuccessfulSubmission(visibleFirmType, visibleFirmId, contactId) {
    this.props.onSuccess(visibleFirmType, visibleFirmId, contactId);
  }

  handleTextChange(event) {
    const rawValue = event.target.value;
    const value = event.target.id === 'contactEmail' ? rawValue.trim() : rawValue;
    this.setState({ [event.target.id]: value });
  }

  handleCompanyStateChange(newValue) {
    this.setState({ state: newValue });
  }

  handleOkClick() {
    const synthName = this.state.contactName + "'s Practice";
    this.setState({ companyName: synthName }, () => this.validateAndSubmit());
  }

  validateAndSubmit() {
    const validation = this.validateForm();
    if (validation.valid) {
      this.submit();
    } else {
      showAlert(this, validation.errorMessage);
    }
  }

  validateForm() {
    return FormProcessor.validateForm(this.state, this.validationPolicy);
  }

  submit() {
    FormProcessor.submitOrgAndContactForm(this);
  }

  cancelForm() {
    this.props.onCancel({ action: 'canceled' });
  }

  handleContactPhone1RolesChange(rolesObj) {
    const newPhoneRoles = constructPhoneRolesString(rolesObj, this.allPossiblePhoneRoles);
    this.setState({ contactPhone1Roles: newPhoneRoles });
  }

  handleContactPhone1NumberChange(newNumber) {
    this.setState({ contactPhone1Number: newNumber });
  }

  handleContactPhone2RolesChange(rolesObj) {
    const newPhoneRoles = constructPhoneRolesString(rolesObj, this.allPossiblePhoneRoles);
    this.setState({ contactPhone2Roles: newPhoneRoles });
  }

  handleContactPhone2NumberChange(newNumber) {
    this.setState({ contactPhone2Number: newNumber });
  }

  handleBusinessTypeChange(newValue) {
    this.setState({ firmType: newValue });
  }

  computeModalTitle() {
    return 'Register ' + this.props.firmType;
  }

  render() {
    const { classes } = this.props;
    const { shouldShowAlertModal, alertModalText } = this.state;
    const title = this.computeModalTitle();
    return (
      <div>
        <AlertModal
          show={shouldShowAlertModal}
          title="Alert"
          text={alertModalText}
          closeFunc={() => this.setState({ shouldShowAlertModal: false })}
        />

        <Modal
          classes={{ modal: classes.newReferrerOrgModal }}
          open={true}
          title={title}
          okButtonLabel="Register"
          cancelButtonLabel="Cancel"
          onOk={() => this.handleOkClick()}
          onCancel={() => this.cancelForm()}
        >
          <NewConsultancyContactPanel ownerModal={this} firmType={this.props.firmType} personLabel={'Practitioner'} />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const actionProducers = {
  setApiResponseInfo,
};

export default connect(mapStateToProps, actionProducers)(withStyles(localStyles)(IcfPractitionerModal));
